import * as types from './faqActionTypes';

export default (
  state = {
    faq: [],
    error: null,
    loading: false,
  },
  action
) => {
  switch (action.type) {
    case types.GET_FAQ_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.GET_FAQ_SUCCESS:
      return {
        ...state,
        loading: false,
        faq: action.faq,
      };
    case types.GET_FAQ_ERROR:
      return {
        ...state,
        faq: {},
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/faq/faqReducer.js